<template>
    <div class="tenant-selector" :class="{ readonly: readonly }">
        <div class="tenant-label">{{ $t('navBar.tenant') }}</div>
        <v-select
            v-model="currentTenant"
            :items="tenants"
            item-text="name"
            item-value="key"
            hide-details
            :readonly="readonly"
            @change="setTenant"
        />
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'TenantSelector',

    data: () => ({
        currentTenant: null,
    }),

    computed: {
        ...mapGetters('context', ['getCurrentTenant', 'getAvailableTenants']),

        tenants() {
            return this.getAvailableTenants || [];
        },

        // Automatically set readonly based on number of available tenants
        readonly() {
            return this.tenants.length <= 1;
        },
    },

    created() {
        this.currentTenant = this.getCurrentTenant;
    },

    methods: {
        ...mapActions('context', ['setCurrentTenant']),

        setTenant(tenantKey) {
            if (!tenantKey) return;

            // Store in Vuex (similar to how setLanguageLocale works)
            this.setCurrentTenant(tenantKey);

            // Redirect to home page (current page might be for an entity that is specific to previous tenant)
            const newUrl = new URL('/', window.location.origin);
            newUrl.searchParams.set('tenant', tenantKey);

            // force a page reload to ensure all data is fetched with new tenant
            window.location.href = newUrl.toString();
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .v-input__append-inner {
        transform: rotate(-90deg);
    }
}

.tenant-label {
    font-size: 1.2rem;
    font-weight: normal;
    padding: 17px;
}

.tenant-selector {
    display: flex;
    align-items: center;

    &.readonly {
        opacity: 0.8;

        ::v-deep {
            .v-input__append-inner {
                display: none; // Hide dropdown arrow for readonly
            }
        }
    }
}
</style>
